import { AuthService } from 'src/app/services/auth.service';
import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { ImportMonitorListItem } from 'src/app/models';
import { ImportMonitorDetailItem } from 'src/app/models/index';
import { ImportMonitorService } from 'src/app/services/import_monitor.service';

import * as displayHelpers from '../../../displayHelpers';

@Component({
  selector: 'app-order-monitor-history',
  templateUrl: './order-monitor-history.component.html',
  styleUrls: ['../order-monitor.component.scss', './../../../app.component.scss']
})
export class ImportMonitorHistoryComponent implements OnInit {
  eventItems: ImportMonitorListItem[] = [];
  model = {
    orderId: ''
  };
  numberOfDays = 3;
  loading = false;
  noMore = false;
  calendarDate = displayHelpers.calendarDate;
  timeout: number;


  constructor(private importMonitorService: ImportMonitorService,
    private authService: AuthService) { }

  ngOnInit() {
    this.getErrorEventItems();
  }

  getErrorEventItems() {
    this.loading = true;
    this.noMore = false;
    this.importMonitorService.getClearedImportMonitorItems(this.numberOfDays).subscribe(items => {
      this.eventItems = items.filter(i => this.model.orderId === '' || i.orderId === this.model.orderId);
      this.loading = false;
    });
  }

  refreshImportMonitorForDays() {
    if (this.numberOfDays < 1) {
      this.numberOfDays = 1;
    }
    this.importMonitorService.getClearedImportMonitorItems(this.numberOfDays).subscribe(items => {
        this.eventItems = items.filter(i => this.model.orderId === '' || i.orderId === this.model.orderId);
        this.loading = false;
      });
  }

  orderIdChanged() {
    if (this.timeout) {
      window.clearTimeout(this.timeout);
    }
    this.timeout = window.setTimeout(t =>  {
      this.getErrorEventItems();
    }, 2000);
  }

  clearItem(event: ImportMonitorDetailItem) {
    this.importMonitorService.clearImportMonitorItem(event).subscribe(item => {
      this.eventItems.splice(this.eventItems.findIndex(e => e.id === event.id), 1);
    });
  }

  getItemReferenceString(item: ImportMonitorListItem) {
    if (!item.eventModel) {
      return '';
    }
    return item.eventModel.wspOrderNo || item.eventModel.designId || '';
  }

  eventMessage(item: ImportMonitorListItem) {
    return item.message || 'Click to view message';
  }

  async claimItem(item: ImportMonitorListItem) {
    item.claimedBy = item.claimedByEntry || (await this.authService.getUser().toPromise()).username;
    this.importMonitorService.claimImportMonitorItem(item).subscribe(it => {
      item.isClaiming = false;
    });
  }

  startClaim(item: ImportMonitorListItem) {
    if (item.claimedBy && item.claimedBy !== '') {
      // unclaim
      item.claimedBy = '';
      this.importMonitorService.claimImportMonitorItem(item).subscribe(it => {
        item.isClaiming = false;
        item.claimedBy = '';
      });
      return;
    }
    item.isClaiming = true;
  }
}
